<p class="maquette-statique">indicateurs works!</p>
